import { useState } from "react";
import { Button, Popconfirm, Space, Table, Typography } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { HelpfulMaterial, HelpfulMaterialFormValues } from "./types";
import { HelpfulMaterialModal } from "./HelpfulMaterialModal";
import { useHelpfulMaterials } from "./useHelpfulMaterials";

export const HelpfulMaterialsTable = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [editingMaterial, setEditingMaterial] = useState<HelpfulMaterial>();
  const {
    loading,
    materials,
    removingIds,
    saving,
    removeMaterial,
    saveMaterial,
  } = useHelpfulMaterials();

  const openCreateModal = () => {
    setEditingMaterial(undefined);
    setModalOpen(true);
  };

  const openEditModal = (material: HelpfulMaterial) => {
    setEditingMaterial(material);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setEditingMaterial(undefined);
  };

  const handleSave = async (values: HelpfulMaterialFormValues) => {
    await saveMaterial(values);
    closeModal();
  };

  return (
    <>
      <Table<HelpfulMaterial>
        title={() => (
          <Space>
            <strong>Полезные файлы</strong>
            <Button
              size="small"
              type="primary"
              icon={<PlusOutlined />}
              onClick={openCreateModal}
            >
              Добавить файл
            </Button>
          </Space>
        )}
        dataSource={materials}
        loading={loading}
        rowKey="id"
        pagination={false}
        locale={{
          emptyText: (
            <div style={{ margin: 56 }}>Полезные файлы отсутствуют</div>
          ),
        }}
      >
        <Table.Column<HelpfulMaterial>
          dataIndex="fileName"
          key="fileName"
          title="Название"
        />
        <Table.Column<HelpfulMaterial>
          dataIndex="linkUrl"
          key="linkUrl"
          title="Файл"
          render={(value) => (
            <Typography.Link href={value} target="_blank" rel="noreferrer">
              {value}
            </Typography.Link>
          )}
        />
        <Table.Column<HelpfulMaterial>
          width={220}
          fixed="right"
          key="actions"
          title="Действия"
          render={(_, record) => (
            <Space size={8} direction="vertical" style={{ width: "100%" }}>
              <Button
                size="small"
                icon={<EditOutlined />}
                onClick={() => openEditModal(record)}
                block
              >
                Редактировать
              </Button>
              <Popconfirm
                title="Удалить материал?"
                okText="Удалить"
                cancelText="Отмена"
                onConfirm={() => removeMaterial(record.id)}
              >
                <Button
                  danger
                  size="small"
                  icon={<DeleteOutlined />}
                  loading={removingIds.includes(record.id)}
                  block
                >
                  Удалить
                </Button>
              </Popconfirm>
            </Space>
          )}
        />
      </Table>

      <HelpfulMaterialModal
        open={modalOpen}
        saving={saving}
        material={editingMaterial}
        onCancel={closeModal}
        onSubmit={handleSave}
      />
    </>
  );
};
